const tenprinciplesSectionList =
[
  // human rights
  {
    key:['Q156'],
    multiselect: true,
    description: "Human Rights - How does your company take the human rights principles into account in its policies or practices?",
    dropDownQuestion: "Human Rights, actions taken",
    optionMap: {
      '1': 'Set of corporate principles on human rights specifically',
      '2': 'Within an overall corporate code or principles',
      '3': 'Human rights risk assessment',
      '4': 'Human rights impact assessment',
      '5': 'Operational guidance notes',
      '6': 'Complaint mechanism',
      '7': 'Training and awareness programmes for employees',
      '8': 'Supply chain and subcontracting arrangements',
      '9': 'Employee performance assessment',
      '10': 'Monitor and evaluate performance',
      '11': 'Public disclosure of human rights policies and practices',
      '12': 'Participate in industry or issue-specific initiatives',
      '13': 'Multi-stakeholder dialogue',
      '14': 'Other (please specify)',
      '15': 'Unsure',

    }
  },
  {
    key:['Q158'],
    multiselect: true,
    description: "Human Rights - Which aspects of human rights are addressed in your company’s policies or practices?",
    dropDownQuestion: "Human Rights, aspects addressed",
    optionMap: {
      '1': 'Life, liberty and security of the person',
      '2': 'Forced labour',
      '3': 'Child labour',
      '4': 'Right to privacy',
      '5': 'Non-discrimination',
      '6': 'Gender equality',
      '7': 'Workplace health and safety',
      '8': 'Adequate standard of living',
      '9': 'Health',
      '10': 'Freedom of association and other rights at work',
      '11': 'Forced displacement',
      '12': 'Other (please specify)',
      '13': 'Unsure',

    }
  },
  {
    key:['Q99'],
    description: "Human Rights - To what extent has the Global Compact had impact on how your company addresses human rights?",
    dropDownQuestion: "UN Global Compact's impact on how company addresses Human Rights",
    optionMap: {
      '1': 'None',
      '2': 'Minimal',
      '3': 'Moderate',
      '4': 'Significant',
      '5': 'Essential',
    }
  },
  {
    key:['Q110'],
    multiselect: true,
    description: "Human Rights - Which of the following Global Compact offerings had impact on how your company addresses human rights?",
    dropDownQuestion: "How UN Global Compact impacted on Human Rights",
    optionMap: {
      '1': 'Universal value of the ten principles',
      '2': 'Tools and resources',
      '3': 'In-person event',
      '4': 'Online event',
      '5': 'Support from Local Network',
      '6': 'Action Platform participation',
      '7': 'Special Initiatives (e.g. Women’s Empowerment Principles)',
      '8': 'Completing the annual Communication on Progress',
      '9': 'Public policy dialogue',
      '10': 'Other',

    }
  },

  // Labour Rights
  {
    key:['Q163'],multiselect: true,
    description: "Labour - How does your company take the labour principles into account in its policies or practices?",
    dropDownQuestion: "Labour Rights policies in place",
    optionMap: {
      '1': 'Recognize that all workers are free to form and join a trade union of their choice',
      '2': 'Policy not to use or benefit from forced labour',
      '3': 'Policy not to use or benefit from child labour',
      '4': 'Non-discrimination policy',
      '5': 'Equal opportunity policy',
      '6': 'Policy to ensure safe working conditions',
      '7': 'Other (please specify)',
      '8': 'Unsure',

    }
  },
  {
    key:['Q169'],
    multiselect: true,
    description: "Labour - What actions does your company take to implement the labour principles?",
    dropDownQuestion: "Labour Rights actions taken",
    optionMap: {
      '1': "Participate in institutional framework for industrial relations and collective bargaining",
      '2': "Working conditions and terms of employment are addressed through collective bargaining",
      '3': "Labour rights risk assessment",
      '4': "Labour rights impact assessment",
      '5': "Take steps to avoid exclusion of union members from employment",
      '6': "Reliable mechanisms for age verification",
      '7': "Support vocational training and counseling programmes",
      '8': "Training and awareness programmes for employees",
      '9': "Supply chain and subcontracting arrangements",
      '10': "Monitor and evaluate performance",
      '11': "Public disclosure of labour policies and practices",
      '12': "Participate in industry or issue-specific initiatives",
      '13': "Multi-stakeholder dialogue",
      '14': "Other (please specify)",
      '15': "Unsure",

    }
  },
  {
    key:['Q100'],
    description: "Labour Rights - To what extent has the Global Compact had impact on how your company addresses labour rights?",
    dropDownQuestion: "UN Global Compact's impact on how company addresses Labour Rights",
    optionMap: {
      '1': 'None',
      '2': 'Minimal',
      '3': 'Moderate',
      '4': 'Significant',
      '5': 'Essential',
    }
  },
  {
    key:['Q111'],
    multiselect: true,
    description: "Labour Rights - Which of the following Global Compact offerings had impact on how your company addresses labour rights?",
    dropDownQuestion: "How UN Global Compact impacted on Labour Rights",
    optionMap: {
      '1': "Universal value of the ten principles",
      '2': "Tools and resources",
      '3': "In-person event",
      '4': "Online event",
      '5': "Support from Local Network",
      '6': "Action Platform participation",
      '7': "Special Initiatives (e.g. ILO Helpdesk)",
      '8': "Completing the annual Communication on Progress",
      '9': "Public policy dialogue",
      '10': "Other (please explain)",

    }
  },
  // Environment
  {
    key:['Q174'],
    multiselect: true,
    description: "Environment - How does your company take the environmental principles into account in its policies or practices?",
    dropDownQuestion: "Environment policies in place",
    optionMap: {
      '1': "Voluntary charters or codes",
      '2': "Performance targets and indicators",
      '3': "Cleaner and safer production objectives",
      '4': "Sustainable consumption and responsible use objectives",
      '5': "Other",
      '6': "Unsure",

    }
  },
  {
    key:['Q176'],
    multiselect: true,
    description: "Environment - What actions does your company take to implement the environmental principles?",
    dropDownQuestion: "Environment actions taken",
    optionMap: {
      '1': 'Environmental management systems',
      '2': 'Life-cycle assessment and costing',
      '3': 'Water footprinting',
      '4': 'Environmental risk assessment',
      '5': 'Environmental impact assessment',
      '6': 'Eco-design',
      '7': 'Resource efficiency',
      '8': 'Use environmentally-friendly technologies and solutions',
      '9': 'Emissions trading',
      '10': 'Training and awareness programmes for employees',
      '11': 'Supply chain and subcontracting arrangements',
      '12': 'Monitor and evaluate performance',
      '13': 'Report greenhouse gas emissions and strategic climate change data',
      '14': 'Public disclosure of environmental policies and practices',
      '15': 'Participate in industry or issue-specific initiatives',
      '16': 'Multi-stakeholder dialogue',
      '17': 'Other (please specify)',
      '18': 'Unsure',

    }
  },
  {
    key:['Q178_2'],
    description: "Environment - To what extent does your company address Climate change?",
    dropDownQuestion: "Climate change, aspects addressed",
    optionMap: {
      '1': 'Not addressed',
      '2': 'Minimal integration into company strategy and operations',
      '3': 'Moderate integration into company strategy and operations',
      '4': 'Significant integration into company strategy and operations',
      '5': 'Fully integrated into company strategy and operations',

    }
  },
  {
    key:['Q178_3'],
    description: "Environment - To what extent does your company address Water?",
    dropDownQuestion: "Water, aspects addressed",
    optionMap: {
      '1': 'Not addressed',
      '2': 'Minimal integration into company strategy and operations',
      '3': 'Moderate integration into company strategy and operations',
      '4': 'Significant integration into company strategy and operations',
      '5': 'Fully integrated into company strategy and operations',

    }
  },
  {
    key:['Q178_4'],
    description: "Environment - To what extent does your company address Biodiversity?",
    dropDownQuestion: "Biodiversity, aspects addressed",
    optionMap: {
      '1': 'Not addressed',
      '2': 'Minimal integration into company strategy and operations',
      '3': 'Moderate integration into company strategy and operations',
      '4': 'Significant integration into company strategy and operations',
      '5': 'Fully integrated into company strategy and operations',

    }
  },
  {
    key:['Q178_5'],
    description: "Environment - To what extent does your company address Renewable energy sources?",
    dropDownQuestion: "Renewable energy sources, aspects addressed",
    optionMap: {
      '1': 'Not addressed',
      '2': 'Minimal integration into company strategy and operations',
      '3': 'Moderate integration into company strategy and operations',
      '4': 'Significant integration into company strategy and operations',
      '5': 'Fully integrated into company strategy and operations',

    }
  },
  {
    key:['Q101'],
    description: "Environment - To what extent has the Global Compact had impact on how your company addresses environment?",
    dropDownQuestion: "UN Global Compact's impact on how company addresses Environment",
    optionMap: {
      '1': 'None',
      '2': 'Minimal',
      '3': 'Moderate',
      '4': 'Significant',
      '5': 'Essential',
    }
  },
  {
    key:['Q112'],
    multiselect: true,
    description: "Environment - Which of the following Global Compact offerings had impact on how your company addresses the environment?",
    dropDownQuestion: "How UN Global Compact impacted on Environment",
    optionMap: {
      '1': "Universal value of the ten principles",
      '2': "Tools and resources",
      '3': "In-person event",
      '4': "Online event",
      '5': "Support from Local Network",
      '6': "Action Platform participation",
      '7': "Special Initiatives (e.g. CEO Water Mandate, Caring for Climate)",
      '8': "Completing the annual Communication on Progress",
      '9': "Public policy dialogue",
      '10': "Other (please explain)",

    }
  },
  // Anti-Corruption
  {
    key:['Q181'],
    multiselect: true,
    description: "Anti-Corruption - How does your company take the anti-corruption principle into account in its policies or practices?",
    dropDownQuestion: "Anti-Corruption, policies in place",
    optionMap: {
      '1': 'Explicit policy addressing anti-corruption',
      '2': 'Within an overall corporate code or principles',
      '3': 'Zero-tolerance policy towards corruption',
      '4': 'Specialized unit within the company (e.g. an ethics/compliance officer, oversight board)',
      '5': 'Pre-approval of facilitation payments required',
      '6': 'Political donations publicized',
      '7': 'Policies limiting the value of gifts',
      '8': 'Policies on donations to charitable organizations',
      '9': 'Policy against collusion',
      '10': 'Other (please specify)',
      '11': 'Unsure',

    }
  },
  {
    key:['Q183'],
    multiselect: true,
    description: "Anti-Corruption - What actions does your company take to implement the anti-corruption principle?",
    dropDownQuestion: "Anti-Corruption, actions taken",
    optionMap: {
      '1': 'Management systems addressing bribery and anti-corruption',
      '2': 'Corruption risk assessment',
      '3': 'Corruption impact assessment',
      '4': 'Anti-corruption policy is publicly accessible',
      '5': 'Anonymous hotline for reporting of corruption instances',
      '6': 'Sanction system for corruption breaches by employees',
      '7': 'Country Managers sign “no bribery” certifications',
      '8': 'Terminate contracts with suppliers if corruption occurs',
      '9': 'Training and awareness programmes for employees',
      '10': 'Supply chain and subcontracting arrangements',
      '11': 'Record instances of corruption',
      '12': 'Record facilitation payments and gifts',
      '13': 'Monitor and evaluate performance',
      '14': 'Public disclosure of anti-corruption policies and practices',
      '15': 'Engage in collective action',
      '16': 'Participate in industry or issue-specific initiatives',
      '17': 'Multi-stakeholder dialogue',
      '18': 'Other (please specify)',
      '19': 'Unsure',

    }
  },
  {
    key:['Q102'],
    description: "Anti-Corruption - To what extent has the Global Compact had impact on how your company addresses Anti-Corruption?",
    dropDownQuestion: "UN Global Compact's impact on how company addresses Anti-Corruption",
    optionMap: {
      '1': 'None',
      '2': 'Minimal',
      '3': 'Moderate',
      '4': 'Significant',
      '5': 'Essential',
    }
  },
  {
    key:['Q113'],
    multiselect: true,
    description: "Anti-Corruption - Which of the following Global Compact offerings had impact on how your company addresses the Anti-Corruption?",
    dropDownQuestion: "How UN Global Compact impacted on Anti-Corruption",
    optionMap: {
      '1': "Universal value of the ten principles",
      '2': "Tools and resources",
      '3': "In-person event",
      '4': "Online event",
      '5': "Support from Local Network",
      '6': "Action Platform participation",
      '7': "Special Initiatives (e.g. Call to Action: Anti-Corruption and the Global Development Agenda)",
      '8': "Completing the annual Communication on Progress",
      '9': "Public policy dialogue",
      '10': "Other (please explain)",

    }
  },
]

export {tenprinciplesSectionList};



// WEBPACK FOOTER //
// ./src/App/data/tenprinciplesSectionList.js